import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const ADMIN_TOKEN_KEY = "bos_admin_token";

// Attach the admin bearer token to every request when present.
// Public endpoints ignore it; protected endpoints require it.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const LS_KEY = "bos_scans";

export function saveScanId(id) {
  try {
    const list = JSON.parse(localStorage.getItem(LS_KEY) || "[]");
    if (!list.includes(id)) {
      list.unshift(id);
      localStorage.setItem(LS_KEY, JSON.stringify(list.slice(0, 50)));
    }
  } catch (e) {
    localStorage.setItem(LS_KEY, JSON.stringify([id]));
  }
}

export function getScanIds() {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || "[]");
  } catch (e) {
    return [];
  }
}

const SAVED_KEY = "bos_saved";

export function getSavedKeys() {
  try {
    return JSON.parse(localStorage.getItem(SAVED_KEY) || "[]");
  } catch (e) {
    return [];
  }
}

export function addSavedKey(key) {
  if (!key) return;
  try {
    const list = getSavedKeys().filter((k) => k !== key);
    list.unshift(key);
    localStorage.setItem(SAVED_KEY, JSON.stringify(list.slice(0, 50)));
  } catch (e) {
    localStorage.setItem(SAVED_KEY, JSON.stringify([key]));
  }
}

export function removeSavedKey(key) {
  try {
    localStorage.setItem(SAVED_KEY, JSON.stringify(getSavedKeys().filter((k) => k !== key)));
  } catch (e) { /* noop */ }
}

// Reputation business keys — lets the Fix Plan surface tasks created from Reputation Recovery
// for a business that may not have a full scan yet.
const REP_KEY = "bos_rep_keys";

export function getRepKeys() {
  try { return JSON.parse(localStorage.getItem(REP_KEY) || "[]"); } catch (e) { return []; }
}

export function addRepKey(key) {
  if (!key) return;
  try {
    const list = getRepKeys().filter((k) => k !== key);
    list.unshift(key);
    localStorage.setItem(REP_KEY, JSON.stringify(list.slice(0, 50)));
  } catch (e) { localStorage.setItem(REP_KEY, JSON.stringify([key])); }
}

// Active in-flight scan — lets the wizard reconnect to a running scan after a refresh/close.
const ACTIVE_SCAN_KEY = "bos_active_scan";

export function setActiveScan(id, biz, mode) {
  try {
    localStorage.setItem(ACTIVE_SCAN_KEY, JSON.stringify({ id, biz: biz || {}, mode: mode || "bi", ts: Date.now() }));
  } catch (e) { /* noop */ }
}

export function getActiveScan() {
  try {
    const v = JSON.parse(localStorage.getItem(ACTIVE_SCAN_KEY) || "null");
    // Ignore stale pointers older than 30 min.
    if (v && Date.now() - (v.ts || 0) < 30 * 60 * 1000) return v;
  } catch (e) { /* noop */ }
  return null;
}

export function clearActiveScan() {
  try { localStorage.removeItem(ACTIVE_SCAN_KEY); } catch (e) { /* noop */ }
}

// FastAPI 422 returns an array of {msg} objects; render a safe string, never the raw object.
export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtMoney(x, currency = "USD") {
  if (x == null || isNaN(Number(x))) return "—";
  const n = Number(x);
  const s = n.toLocaleString("en-US", { maximumFractionDigits: n % 1 === 0 ? 0 : 2 });
  return currency === "USD" ? `$${s}` : `${s}`;
}

export function fmtRange(r, currency = "USD") {
  if (!r) return "—";
  if (r.exact || r.low === r.high) return fmtMoney(r.low ?? r.high, currency);
  return `${fmtMoney(r.low, currency)}–${fmtMoney(r.high, currency)}`;
}
